export default {
  setCities (state, { cities }) {
    state.cities = cities
  },

  setLanguages (state, { languages }) {
    state.languages = languages
  },

  appendOccupations (state, { occupations }) {
    state.occupations = [...state.occupations, ...occupations]
  },

  setSkills (state, { skills }) {
    state.skills = skills
  },

  setWorklocations (state, { worklocations }) {
    state.worklocations = worklocations
  },

  reset (state) {
    state.cities = []
    state.languages = []
    state.occupations = []
    state.skills = []
    state.worklocations = []
  },

  resetResources (state) {
    state.cities = []
    state.languages = []
    state.occupations = []
    state.skills = []
    state.worklocations = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/resources/mutations.js